export default "__VITE_ASSET__DcmunCZW__"